import {alias, createModelSchema, identifier, reference,} from "serializr";
import {Cloneable} from "@/common/Cloneable";
import {Schema} from "@/common/Schema";

export class ProductStatus extends Cloneable {
    static NONE = new ProductStatus(0, "NONE");

    static _values = [
        this.NONE,
        new ProductStatus(1, "BOUGHT"),
        new ProductStatus(2, "NOT_BOUGHT")
    ];

    static getValues() {
        return ProductStatus._values;
    }

    static getValue(id) {
        let value = ProductStatus._values.find(v => v.id === id) || null;
        console.assert(value, "unknown model: " + id);
        return value;
    }

    static schema() {
        return reference("id", (id, cb) => {
            return cb(null, ProductStatus.getValue(id));
        });
    }

    static is(value) {
        if (value instanceof ProductStatus) {
            return ProductStatus._values.some(v => v.id === value.id);
        } else {
            return false;
        }
    }

    static isNone(value) {
        return ProductStatus.NONE.equal(value);
    }

    constructor(id = 0, name = "NONE") {
        super();
        this._id = id;
        this._name = name;
    }

    get id() {
        return this._id;
    }

    get name() {
        return this._name;
    }

    equal(value) {
        if (value instanceof ProductStatus) {
            return this.id === value.id;
        }
        return false;
    }

    clone(target = undefined) {
        if (!target) {
            return super.clone(new ProductStatus());
        } else if (target instanceof ProductStatus) {
            return super.clone(target);
        } else {
            console.assert(false);
            return undefined;
        }
    }
}

createModelSchema(ProductStatus, {
    _id: alias("id", identifier()),
    _name: alias("name", Schema.primitive())
});